import {
  INFO_MSG, WARN_MSG, ERROR_MSG, DISMISS_ALL, LOADING, SWITCH_MODE_CALENDRIER, SELECT_MOIS, SELECT_SEMAINE_INDEX
} from '../actions/navigation';
import {allSemaines, allMois} from '../data/Calendrier';

export default function (
    state = {
      byMois: true,
      mois: allMois[0],
      semainesVisibles: allSemaines.filter(s => s.codeMois === allMois[0].code),
      semaineIndex: 0
    },
    action
) {
  switch (action.type) {
    case SWITCH_MODE_CALENDRIER:
      return {
        ...state,
        byMois: !state.byMois,
        semainesVisibles: semainesVisibles(!state.byMois, state.mois, state.semaineIndex)
      };
    case SELECT_MOIS:
      return {
        ...state,
        mois: action.mois,
        semainesVisibles: semainesVisibles(state.byMois, action.mois, state.semaineIndex)
      };
    case SELECT_SEMAINE_INDEX:
      return {
        ...state,
        semaineIndex: action.semaineIndex.limit(0, allSemaines.length - 5),
        semainesVisibles: semainesVisibles(state.byMois, state.mois, action.semaineIndex.limit(0, allSemaines.length - 5))
      };
    case INFO_MSG:
      return {...state, infomsg: action.message};
    case WARN_MSG:
      return {...state, warnmsg: action.message};
    case ERROR_MSG:
      return {...state, errormsg: action.message};
    case DISMISS_ALL:
      return {...state, infomsg: '', warnmsg: '', errormsg: ''};
    case LOADING:
      return {...state, loading: action.active};
    default:
      return state;
  }
}

function semainesVisibles(byMois, mois, semaineIndex) {
  if (byMois) {
    return allSemaines.filter(s => s.codeMois === mois.code);
  } else {
    return allSemaines.slice(semaineIndex, semaineIndex + 5);
  }
}
